const tables = [
  {
    name: "Number",
  },
  {
    name: "Purchase",
  },
  {
    name: "Date",
  },
  {
    name: "Amount",
  },
  {
    name: "Action",
  },
];

export default tables;
